import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateRemoveStatementItem } from '../../models'

// Hook-only command (ADR-2): immediate delete, no confirmation — Angular
// parity (BHV-042).
export const useRemoveStatementItemPresenter = () => {
  const intl = useProcurifyIntl()
  const { removeStatementItem, isRemoving } = useMutateRemoveStatementItem()

  const remove = async (statementItemId: number): Promise<void> => {
    try {
      await removeStatementItem({ statementItemId })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    commands: {
      remove,
    },
    states: {
      isRemoving,
    },
  }
}
